import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { myHubKeys } from './query-keys';
import { ArticleSourceType, ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { AxiosResponse } from 'axios';
import { MyHubAPI } from '../apis';

function useMyHubQuery({
  articleType,
  companyId,
  shouldFetch = true,
  username,
}: {
  articleType: ArticleSourceType;
  companyId: string;
  shouldFetch?: boolean;
  username: string;
}) {
  const { data: hubData, ...rest } = useQuery<AxiosResponse<ArticleType[]>>({
    queryKey: myHubKeys.getMyHub({ articleType, companyId, username }),
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    enabled: shouldFetch && !!(companyId && articleType && username),
    queryFn: () => MyHubAPI.getMyTasks({ companyId, articleType, username }),
  });
  const tasks = useMemo(
    () => (hubData?.data && Array.isArray(hubData.data) ? hubData.data || [] : []),
    [hubData],
  );

  return {
    tasks,
    ...rest,
  };
}

export default useMyHubQuery;
